import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToasterService } from '@abp/ng.theme.shared';
import { ImpersonationService } from '../services/impersonation.service';

/**
 * Guard to block access to certain routes during impersonation.
 * Use this guard on routes that should not be accessible when impersonating another user.
 * Example usage in routes:
 * {
 *   path: 'settings',
 *   component: SettingsComponent,
 *   canActivate: [impersonationBlockGuard]
 * }
 */
export const impersonationBlockGuard: CanActivateFn = () => {
  const impersonationService = inject(ImpersonationService);
  const router = inject(Router);
  const toaster = inject(ToasterService);

  if (impersonationService.isImpersonating) {
    toaster.warn('Impersonation:ActionBlocked');
    router.navigate(['/']);
    return false;
  }

  return true;
};
